module.exports = __webpack_public_path__ + "img/feature-details.202c8a93.svg";